import { render, staticRenderFns } from "./DataNav.vue?vue&type=template&id=32696564&scoped=true&"
import script from "./DataNav.vue?vue&type=script&lang=js&"
export * from "./DataNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32696564",
  null
  
)

export default component.exports